/* Fixes agreed on the 2026-09-17/19 calls: accessible labels, discount copy,
   hero button legibility, menu wording, mobile header contrast, brand spelling,
   coloured filter pills, double-escaped entities in the context tabs, PDP
   gallery/variant sync, and stalled lazy images. */
(function(){
  function txt(el){ return (el.textContent||'').replace(/\s+/g,' ').trim(); }

  function nameFor(el){
    var c = typeof el.className === 'string' ? el.className : '';
    if(/close/i.test(c)) return 'Close';
    if(/prev/i.test(c)) return 'Previous';
    if(/next/i.test(c)) return 'Next';
    if(/search/i.test(c)) return 'Search';
    if(/bag|cart/i.test(c)) return 'Open bag';
    if(/burger|menu/i.test(c)) return 'Open menu';
    if(/minus|dec/i.test(c)) return 'Decrease quantity';
    if(/plus|inc/i.test(c)) return 'Increase quantity';
    if(/remove|bin|trash/i.test(c)) return 'Remove item';
    if(/quick|add/i.test(c)){
      var card = el.closest('.sa-card, .sa-rail__card, .card, li, article');
      var t = card && card.querySelector('.sa-card__title, .card__heading, h3, h2');
      return t ? 'Quick add ' + txt(t) : 'Quick add';
    }
    if(/dot|swatch|colour|color/i.test(c)){
      var lbl = el.getAttribute('data-colour') || el.getAttribute('data-color') || el.title;
      return lbl ? 'Show ' + lbl : 'Choose colour';
    }
    if(/tab/i.test(c)) return 'Switch view';
    return 'Open';
  }

  function label(root){
    var nodes = (root||document).querySelectorAll('button, a[role=button], [role=button], summary');
    for(var i=0;i<nodes.length;i++){
      var el = nodes[i];
      if(el.getAttribute('aria-label') || el.getAttribute('aria-labelledby') || el.getAttribute('title')) continue;
      if(txt(el)) continue;
      el.setAttribute('aria-label', nameFor(el));
    }
    var imgs = (root||document).querySelectorAll('img:not([alt])');
    for(var j=0;j<imgs.length;j++){ imgs[j].setAttribute('alt',''); imgs[j].setAttribute('role','presentation'); }
  }

  function hero(root){
    var btns = (root||document).querySelectorAll('.sa-hero .sa-btn-ghost');
    for(var i=0;i<btns.length;i++){
      var b = btns[i];
      if(b.dataset.saPlate) continue;
      b.dataset.saPlate = '1';
      b.style.setProperty('background','rgba(255,255,255,.94)','important');
      b.style.setProperty('color','#15150f','important');
      b.style.setProperty('border-color','#ffffff','important');
      b.style.setProperty('backdrop-filter','blur(4px)','important');
      b.style.setProperty('-webkit-backdrop-filter','blur(4px)','important');
      b.addEventListener('mouseenter', function(e){ e.currentTarget.style.setProperty('background','#ffffff','important'); });
      b.addEventListener('mouseleave', function(e){ e.currentTarget.style.setProperty('background','rgba(255,255,255,.94)','important'); });
    }
  }

  var INK = '#15150f';
  function headerContrast(){
    if (window.innerWidth > 989) return;
    var bar = document.querySelector('.sa-header .sa-header__bar');
    if (!bar) return;
    var text = bar.querySelectorAll('a, button, span, svg');
    for (var i = 0; i < text.length; i++) {
      var el = text[i];
      if (el.closest('.sa-header__pip')) continue;
      el.style.setProperty('color', INK, 'important');
      el.style.setProperty('text-shadow', 'none', 'important');
      if (String(el.tagName).toLowerCase() === 'svg') el.style.setProperty('fill', INK, 'important');
    }
    var lines = document.querySelectorAll('.sa-header .sa-header__burgerline');
    for (var j = 0; j < lines.length; j++) lines[j].style.setProperty('background', INK, 'important');
    var pips = document.querySelectorAll('.sa-header .sa-header__pip');
    for (var k = 0; k < pips.length; k++) {
      pips[k].style.setProperty('background', INK, 'important');
      pips[k].style.setProperty('color', '#f4f2ed', 'important');
    }
  }

  var SHADES = {
    ink:'#1E2230', mocha:'#8A6A55', ash:'#8E8D88', oat:'#D8CCB8',
    mist:'#B9C3C4', sage:'#8D9479', cherry:'#6E1F2A', honey:'#C8964F',
    taro:'#B7A3C4', blush:'#E6C2BD', amber:'#B8743A', cream:'#EFE7D6'
  };
  function textOn(hex){
    var r = parseInt(hex.slice(1,3),16)/255, g = parseInt(hex.slice(3,5),16)/255, b = parseInt(hex.slice(5,7),16)/255;
    function lin(c){ return c <= 0.03928 ? c/12.92 : Math.pow((c+0.055)/1.055, 2.4); }
    var L = 0.2126*lin(r) + 0.7152*lin(g) + 0.0722*lin(b);
    return L > 0.45 ? INK : '#ffffff';
  }
  function paintPills(root){
    var scope = (root && root.querySelectorAll) ? root : document;
    var inputs = scope.querySelectorAll('input[name="filter.v.option.color"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      var hex = SHADES[String(inp.value || '').trim().toLowerCase()];
      if (!hex) continue;
      var pill = inp.closest('label') ||
                 (inp.id ? document.querySelector('label[for="' + inp.id + '"]') : null) ||
                 inp.parentElement;
      if (!pill || pill.dataset.saPainted === hex) continue;
      pill.dataset.saPainted = hex;
      pill.classList.add('sa-colour-pill');
      var fg = textOn(hex);
      if (fg === INK) pill.classList.add('is-light'); else pill.classList.remove('is-light');
      pill.style.setProperty('background', hex, 'important');
      pill.style.setProperty('color', fg, 'important');
      pill.style.setProperty('border-color', fg === INK ? 'rgba(21,21,15,.22)' : 'transparent', 'important');
      var kids = pill.querySelectorAll('span, small, em');
      for (var k = 0; k < kids.length; k++) kids[k].style.setProperty('color', fg, 'important');
    }
  }

  /* Luca, 2026-09-19. Real journey that broke: filter New In by Cherry, tap a
     product shown in Cherry, and the PDP opens with "COLOUR: Cherry" selected
     and the swatch ringed, but the gallery is still on slide 1, the Ink shot.
     She sees black. The gallery only moved on a swatch click, never when the
     variant arrived pre-selected in the URL. */
  var syncTries = 0;
  function selectedVariantId(){
    var fromUrl = new URLSearchParams(location.search).get('variant');
    if (fromUrl) return fromUrl;
    var input = document.querySelector('form.sa-pdp__form [name="id"]');
    return input ? input.value : null;
  }
  function syncGallery(){
    var data = document.querySelector('script[data-sa-pdp-variants]');
    var track = document.querySelector('.sa-pdp__media');
    if (!data || !track || track.dataset.saSynced) return;

    var id = selectedVariantId();
    if (!id) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch(e){ return; }

    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) { v = variants[i]; break; }
    }
    if (!v || !v.media) return;

    var slide = track.querySelector('[data-media-id="' + v.media + '"]');
    if (!slide) return;

    var target = slide.offsetLeft - track.offsetLeft;
    if (target > 0) {
      /* scrollLeft on its own is swallowed by scroll-snap: x mandatory.
         scrollTo with an explicit instant behaviour lands and sticks. */
      track.scrollTo({ left: target, behavior: 'instant' });
    }
    /* Only stop retrying once it has actually landed: images finish loading
       after first paint and shift the offsets, so an early pass can miss. */
    if (Math.abs(track.scrollLeft - target) < 40 || ++syncTries > 25) {
      track.dataset.saSynced = '1';
    }
  }

  /* An <img> whose src/srcset is rewritten after the browser has run its lazy
     pass can end up with currentSrc empty and never fetch at all, which is why
     some collection cards rendered blank. Nudge those back to life. */
  function kickStalledImages(){
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete && img.naturalWidth > 0) continue;
      if (img.currentSrc) continue;
      var box = img.getBoundingClientRect();
      if (box.width === 0 && box.height === 0) continue;
      /* Only what is on screen or just below, so we don't force the whole grid. */
      if (box.bottom < -300 || box.top > window.innerHeight + 600) continue;
      var src = img.getAttribute('src');
      if (!src) continue;
      var srcset = img.getAttribute('srcset');
      img.setAttribute('loading', 'eager');
      if (srcset) img.setAttribute('srcset', srcset);
      img.setAttribute('src', src);
    }
  }

  function wording(s){
    return s
      .replace(/Shop all\s+Shop by\s+/gi, 'Shop all ')
      .replace(/Shop all\s+Activity\b/gi, 'Shop all activities')
      .replace(/Shop all\s+Category\b/gi, 'Shop all categories')
      .replace(/Shop all\s+Colour\b/gi, 'Shop all colours')
      .replace(/Shop all\s+Fit\b/gi, 'Shop all fits');
  }

  var ENTS = { '&amp;':'&', '&#38;':'&', '&quot;':'"', '&#34;':'"', '&#39;':"'", '&apos;':"'", '&lt;':'<', '&gt;':'>' };
  var ENT_RE = /&(?:amp|#38|quot|#34|#39|apos|lt|gt);/g;
  function decode(s){ return s.replace(ENT_RE, function(m){ return ENTS[m] || m; }); }

  var CODE_RE = /(\buse code\s*)?\bFIRST\s?1[25]\b(\s*at checkout)?/gi;
  var OFFER = 'Sign up to get 12% off your first order';
  var BRAND_RE = /Simply\s?Active\b/g;
  function brand(s){ return s.replace(BRAND_RE, 'Simplyactiv'); }

  function skip(node){
    var p = node.parentElement;
    return !p || !!p.closest('script, style, noscript, template');
  }

  function copy(root){
    var scope = (root && root.nodeType === 1) ? root : document.body;
    if(!scope) return;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
    var hits = [], n;
    while((n = walker.nextNode())){
      if (skip(n)) continue;
      var v = n.nodeValue;
      BRAND_RE.lastIndex = 0; ENT_RE.lastIndex = 0; CODE_RE.lastIndex = 0;
      if(CODE_RE.test(v) || BRAND_RE.test(v) || ENT_RE.test(v) || /\b15%\s*off your first/i.test(v) ||
         /Shop all\s+(Shop by|Activity|Category|Colour|Fit)\b/i.test(v)) hits.push(n);
      BRAND_RE.lastIndex = 0; ENT_RE.lastIndex = 0; CODE_RE.lastIndex = 0;
    }
    for(var i=0;i<hits.length;i++){
      var node = hits[i], val = node.nodeValue;
      CODE_RE.lastIndex = 0;
      val = val.replace(CODE_RE, OFFER);
      val = val.replace(/\b15%\s*off your first/gi, '12% off your first');
      val = wording(val);
      val = brand(val);
      val = decode(val);
      if(val !== node.nodeValue) node.nodeValue = val;
    }
    var chips = scope.querySelectorAll ? scope.querySelectorAll('[data-copy-code], .sa-slide__code, .sa-mmm__code') : [];
    for(var c=0;c<chips.length;c++){ chips[c].hidden = true; chips[c].style.display = 'none'; }

    var attrEls = scope.querySelectorAll ? scope.querySelectorAll('[alt],[title],[aria-label],[placeholder]') : [];
    for(var a=0;a<attrEls.length;a++){
      var el = attrEls[a];
      ['alt','title','aria-label','placeholder'].forEach(function(at){
        var v2 = el.getAttribute(at);
        if(!v2) return;
        BRAND_RE.lastIndex = 0; ENT_RE.lastIndex = 0; CODE_RE.lastIndex = 0;
        var out = decode(brand(v2.replace(CODE_RE, OFFER)));
        CODE_RE.lastIndex = 0;
        if(out !== v2) el.setAttribute(at, out);
        BRAND_RE.lastIndex = 0; ENT_RE.lastIndex = 0; CODE_RE.lastIndex = 0;
      });
    }
    BRAND_RE.lastIndex = 0;
    if (document.title) {
      var t2 = decode(brand(document.title));
      if (t2 !== document.title) document.title = t2;
    }
    BRAND_RE.lastIndex = 0;
  }

  function run(root){
    try{ label(root); hero(root); headerContrast(); paintPills(root); syncGallery(); kickStalledImages(); copy(root); }catch(e){}
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ run(); });
  else run();
  window.addEventListener('load', function(){ run(); });
  /* Images settle late, so re-check for a short while after load. */
  [120, 350, 700, 1200, 2000].forEach(function(ms){ setTimeout(function(){ run(); }, ms); });
  window.addEventListener('scroll', headerContrast, { passive: true });
  window.addEventListener('scroll', kickStalledImages, { passive: true });
  window.addEventListener('resize', headerContrast);
  document.addEventListener('click', function(){ setTimeout(function(){ paintPills(); }, 60); }, true);

  new MutationObserver(function(muts){
    var touchedHeader = false, sawNodes = false;
    for(var i=0;i<muts.length;i++){
      if(muts[i].type === 'attributes'){ touchedHeader = true; continue; }
      for(var j=0;j<muts[i].addedNodes.length;j++){
        var nd = muts[i].addedNodes[j];
        if(nd.nodeType === 1){ run(nd); sawNodes = true; }
      }
    }
    if(touchedHeader) headerContrast();
    if(sawNodes){ paintPills(); syncGallery(); }
  }).observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
})();